import styled, { css } from 'styled-components';
import { ColorAddiWhite, ColorAddiBackgroundWhite, ColorAddiCompFiveDarken5, ColorAddiBackgroundHint, ColorAddiBackgroundMedium } from '@addi/foundation/dist/web/colors';
const baseCss = css `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;

    header {
        padding: 4% 2% 0 2%;
        max-width: 80%;
        line-height: 49px;
        text-align: center;
    }
`;
const primaryEnabledCss = css `
    border-width: 0;
    color: ${ColorAddiWhite};
    background-color: ${ColorAddiCompFiveDarken5};
`;
const disabledCss = css `
    border-width: 1px;
    border-color: ${ColorAddiBackgroundMedium};
    background-color: ${ColorAddiBackgroundHint};
`;
const PanelContainer = styled.div `
    width: auto;
    background-color: ${ColorAddiBackgroundWhite};
    color: ${ColorAddiCompFiveDarken5};
    
    border-color: ${({ selected }) => selected ? ColorAddiBackgroundHint : ColorAddiBackgroundMedium};

    ${({ disabled }) => disabled && disabledCss}
`;
export const PrimaryPanelContainer = styled(PanelContainer) `
    ${baseCss}

    ${({ disabled }) => !disabled && primaryEnabledCss}

    border-width: ${({ border }) => border && `${border}px`};
    border-radius: ${({ radius }) => radius && `${radius}px`};
`;
export const SecondaryPanelContainer = styled(PanelContainer) `
    ${baseCss}

    border-width: ${({ border }) => border && `${border}px`};
    border-radius: ${({ radius }) => radius && `${radius}px`};
`;
//# sourceMappingURL=panel.styled.js.map